import {ServiceListing} from './constants';

export const servicePlaceholderImageUrl = `${process.env.PUBLIC_URL}/placeholder.png`;

export const getServiceIconUrl = (fileName: string) => `${process.env.PUBLIC_URL}/icons/${fileName}`;

export const getServiceDisplayName = (service: ServiceListing) => (
  service.serviceKind === 'college'
    ? service.organizationName || service.providerName
    : service.providerName
);

export const getServiceContactName = (service: ServiceListing) => (
  service.contactName || service.providerName
);

export const getInitials = (name: string) => (
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() || '')
    .join('') || 'U'
);

export const formatServiceDeadline = (value?: string) => {
  if (!value) {
    return undefined;
  }

  const parsedDate = new Date(`${value}T00:00:00.000Z`);
  if (Number.isNaN(parsedDate.getTime())) {
    return value;
  }

  return parsedDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getPrimaryServiceMeta = (service: ServiceListing) => (
  service.location || (
    service.serviceKind === 'college'
      ? `Contact: ${getServiceContactName(service)}`
      : undefined
  )
);

export const getSecondaryServiceMeta = (service: ServiceListing) => {
  const formattedDeadline = formatServiceDeadline(service.deadline);

  return service.availability || (
    formattedDeadline ? `Deadline: ${formattedDeadline}` : service.opportunityType || service.tags[0]
  );
};
